import { useSocket } from "common/hooks/useSocket";
import React, { useContext } from "react";
import { DraftContext } from "../context";
import { RoomContext } from "App/context";
import { DraftCharacter } from "types/Draft/type";
import { useTranslation } from "react-i18next";
import SkewButton from "common/components/SkewButton";
import { useActingRole } from "common/hooks/useActingRole";

const ActionButton = () => {
  const { t } = useTranslation();
  const socket = useSocket();
  const {
    currentStep,
    picksPlayer1,
    picksPlayer2,
    bansPlayer1,
    bansPlayer2,
    selectedPicksPlayer1,
    selectedPicksPlayer2,
    selectedBansPlayer1,
    selectedBansPlayer2,
  } = useContext(DraftContext);
  const { role } = useContext(RoomContext);
  // En solo, le joueur valide pour le camp dont c'est le tour.
  const actingRole = useActingRole();
  const isCaptain = role === "Player 1" || role === "Player 2";
  const currentSelect: DraftCharacter[] | undefined =
    currentStep?.action === "Pick"
      ? actingRole === "Player 1"
        ? selectedPicksPlayer1
        : actingRole === "Player 2"
          ? selectedPicksPlayer2
          : undefined
      : currentStep?.action === "Ban"
        ? actingRole === "Player 1"
          ? selectedBansPlayer1
          : actingRole === "Player 2"
            ? selectedBansPlayer2
            : undefined
        : undefined;
  const myTurn =
    isCaptain &&
    (currentStep?.player === actingRole || currentStep?.player === "Both") &&
    currentSelect !== undefined;

  const onClickConfirm = () => {
    if (myTurn) {
      if (currentStep?.action === "Pick") {
        if (actingRole === "Player 1") {
          socket.emit("send-chars-pick", [
            ...picksPlayer1,
            ...(selectedPicksPlayer1 ?? []),
          ]);
        } else {
          socket.emit("send-chars-pick", [
            ...picksPlayer2,
            ...(selectedPicksPlayer2 ?? []),
          ]);
        }
      } else {
        if (actingRole === "Player 1") {
          if (currentStep?.player === "Both") {
            socket.emit("send-hide-ban", [...(selectedBansPlayer1 ?? [])]);
          } else {
            socket.emit("send-chars-ban", [
              ...bansPlayer1,
              ...(selectedBansPlayer1 ?? []),
            ]);
          }
        } else {
          if (currentStep?.player === "Both") {
            socket.emit("send-hide-ban", [...(selectedBansPlayer2 ?? [])]);
          } else {
            socket.emit("send-chars-ban", [
              ...bansPlayer2,
              ...(selectedBansPlayer2 ?? []),
            ]);
          }
        }
      }
    }
  };

  /*
    Rien ici pour le temps écoulé : c'est le serveur qui décompte et qui joue à la place du
    capitaine quand son budget est épuisé (socket/draftTimer.ts). Ce composant ne fait plus
    que soumettre la sélection du joueur.
  */

  return (
    <SkewButton
      sx={{ width: "fit-content", margin: "auto" }}
      disabled={
        !myTurn ||
        (myTurn && currentSelect.length < (currentStep?.quantity ?? 0))
      }
      onClick={() => onClickConfirm()}
    >
      {!myTurn
        ? t("En attente...")
        : currentStep?.action === "Ban"
        ? t("Bannir {{quantity}}/{{total}}", {
            quantity: currentSelect.length,
            total: currentStep.quantity,
          })
        : t("Verrouiller {{quantity}}/{{total}}", {
            quantity: currentSelect.length,
            total: currentStep?.quantity,
          })}
    </SkewButton>
  );
};

export default ActionButton;
